import React from "react"
import PropTypes from "prop-types"

import PlacesAutocomplete  from 'react-places-autocomplete'
import { geocodeByAddress } from 'react-places-autocomplete'
import DraggableMap from './location/DraggableMap'
import BtnPrimary from '../form_sections/BtnPrimary'

class LocationSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      selectedAddress: '',
      lat: '',
      lng: '',
      loaded: false,
      timeout: null
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.getCurrentUserInfo = this.getCurrentUserInfo.bind(this)
    this.updateLatLng = this.updateLatLng.bind(this)
  }

  updateLatLng(lat, lng) {
    this.setState({
      lat: lat,
      lng: lng
    }, () => this.updateUser())

  }

  handleChange(address) {
    this.setState({
      address,
      lat: '',
      lng: ''
    })
  }

  componentDidMount() {
    if(this.props.signup != true) {
      this.getCurrentUserInfo()
    } else {
      this.setState({
        loaded:true
      })
    }
  }

  getCurrentUserInfo() {
    $.ajax({
      url: `../get_current_user`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        let user = JSON.parse(data.data.current_user)

        this.setState({
          address: user.location != null ? user.location : '',
          selectedAddress: user.location != null ? user.location : '',
          lat: user.lat != null ? parseFloat(user.lat) : '',
          lng: user.lng != null ? parseFloat(user.lng) : '',
          loaded: true
        })
        if (user.location != null && user.lat === null) {
          this.handleSelect(user.location)
        }
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateUser() {
    const { timeout } = this.state;
    clearTimeout(timeout);
    this.setState({
      timeout: setTimeout(() => {
        let data = {
          user: {
            location: this.state.selectedAddress,
            lat: this.state.lat,
            lng: this.state.lng
          }
        }
        $.ajax({
          url: `../update_user`,
          dataType: 'JSON',
          type: 'POST',
          data: data,
          header: {
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.getCurrentUserInfo()
          },
          catch: (error) => {
            console.log('error')
          }
        })
      }, 500)
    })

  }

  // When the user selects an autocomplete suggestion...
  handleSelect(address) {
    // Pull in the setFormLocation function from the parent ReportForm
    //const setFormLocation = this.props.setFormLocation
    geocodeByAddress(address)
      .then((results) => {
        this.setState({
          selectedAddress: results[0].formatted_address,
          address: results[0].formatted_address,
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        }, () => this.updateUser())
        // Set the location in the parent ReportFrom
        //setFormLocation(results[0].formatted_address)
      })
      .catch(error => console.error('Error', error))
  }

  render() {
    const renderInput = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
      <div className="autocomplete-root">
        <input className="input_standard" {...getInputProps()} />
        {suggestions.length > 0 &&
          <div className="autocomplete-dropdown-container dropdownContainer" style={{maxWidth: 400}}>
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                style={{
                  color: '#03a9f4',
                  padding: 10,
                  backgroundColor: 'white',
                  textAlign: 'center'
                }}

                {...getSuggestionItemProps(suggestion)}
                className="suggestion">
                  <h4>{suggestion.description}</h4>
              </div>
            ))}
          </div>
        }
      </div>
    );

    // Limit the suggestions to show only cities in the US
    const searchOptions = {
      types: ['(cities)']
     }

    return (
      <div style={{maxWidth: 450, margin: 'auto', marginTop: 10}}>
        <h4 className="label_standard">What city do you live in?</h4>
        <PlacesAutocomplete
          value={this.state.address}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          searchOptions={searchOptions}
        >
          {renderInput}
        </PlacesAutocomplete>
        {this.state.lat != '' && <div style={{height: '50vh', maxWidth: '90vh', margin: 'auto', marginTop: 30}}>
          <h4 className="label_standard">Drag the circle to your area.</h4>
          <DraggableMap
            lat={this.state.lat}
            lng={this.state.lng}
            updateLatLng={this.updateLatLng}
          />
        </div>}
        {(this.props.signup && this.state.selectedAddress != '') &&
          <div style={{textAlign: 'center', marginTop: 15}}>
            <BtnPrimary
              buttonText="Next: My Languages"
              onClick={() => window.location.replace('/sign_up_languages')}
            />
          </div>
        }
      </div>
    );
  }

}


export default LocationSettings;
